var map = {
	"./l1.jpg": 5082,
	"./l2.jpg": 8806,
	"./l3.jpg": 2727,
	"./l4.jpg": 9001,
	"./l5.jpg": 7285,
	"./l6.jpg": 5716,
	"assets/fashionStyling/editorials/lodz/l1.jpg": 5082,
	"assets/fashionStyling/editorials/lodz/l2.jpg": 8806,
	"assets/fashionStyling/editorials/lodz/l3.jpg": 2727,
	"assets/fashionStyling/editorials/lodz/l4.jpg": 9001,
	"assets/fashionStyling/editorials/lodz/l5.jpg": 7285,
	"assets/fashionStyling/editorials/lodz/l6.jpg": 5716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4079;